import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Tooltip } from 'antd';

import Pficon from 'components/Pficon';
import { SETTINGS_TOOLTIP_TYPES } from 'components/NodeHeaderSettings/constants';

import useTooltipTitle from './hooks/useTooltipTitle';
import { getDataTestId } from './utils';
import { DATA_TEST_ID } from './constants';

const RestoreButton = ({
  valueType,
  isDisabled = false,
  insideMatrix = false,
  action,
  iconClasses = '',
  buttonClasses = '',
  nodeType,
}) => {
  const title = useTooltipTitle(
    valueType,
    nodeType,
    SETTINGS_TOOLTIP_TYPES.RESTORE,
  );
  const buttonElement = (
    <Button
      size="small"
      className={classNames([
        'border-none',
        'outline-blue',
        'padding-none',
        'shadow-none',
        'background-transparent',
        {
          'color-grey-10-hover': !isDisabled,
          'background-transparent-hover': isDisabled,
          'margin-horizontal-xs': insideMatrix,
        },
        buttonClasses,
      ])}
      onClick={action}
      disabled={isDisabled}
      style={{ height: 'auto', fontSize: 12 }}
      data-testid={getDataTestId(valueType, DATA_TEST_ID.RESTORE_BUTTON)}
    >
      <Pficon type="restart" className={iconClasses} />
    </Button>
  );

  if (isDisabled) {
    return buttonElement;
  }

  return (
    <Tooltip
      placement="bottomRight"
      arrowPointAtCenter
      overlayClassName="tooltip-light"
      trigger="hover"
      title={title}
    >
      {buttonElement}
    </Tooltip>
  );
};

RestoreButton.propTypes = {
  valueType: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  insideMatrix: PropTypes.bool,
  action: PropTypes.func.isRequired,
  iconClasses: PropTypes.string,
  buttonClasses: PropTypes.string,
  nodeType: PropTypes.number,
};

export default React.memo(RestoreButton);
